// OTP Translation Override Script
// This script replaces hardcoded English text with Arabic translations

document.addEventListener('DOMContentLoaded', function() {
  // Function to replace OTP text with translations
  function replaceOTPText() {
    // Get current language
    const isArabic = document.documentElement.lang === 'ar' || document.documentElement.lang === 'ar-SA';
    
    if (isArabic) {
      // Replace Get OTP buttons
      const getOTPButtons = document.querySelectorAll('#getOTPButton, #smlEmailOTPDivGetOTPButton');
      getOTPButtons.forEach(button => {
        if (button && button.textContent.trim() === 'Get OTP') {
          button.textContent = 'حصل الكود';
        }
      });
      
      // Replace Submit OTP buttons
      const submitOTPButtons = document.querySelectorAll('#submitOTPButton, #smlEmailOTPDivSubmitOTPButton, #submitEmailOTPButton');
      submitOTPButtons.forEach(button => {
        if (button && button.textContent.trim() === 'Submit OTP') {
          button.textContent = 'إرسال الكود';
        }
      });
      
      // Replace Resend OTP buttons
      const resendOTPButtons = document.querySelectorAll('#resendOTPButton, #smlEmailOTPDivResendOTPButton, #resendEmailOTPButton');
      resendOTPButtons.forEach(button => {
        if (button && button.textContent.trim() === 'Resend OTP') {
          button.textContent = 'إعادة إرسال الكود';
        }
      });
      
      // Replace Get OTP on WhatsApp button
      const whatsappButton = document.querySelector('#smlGetOTPOnWhatsAppButton');
      if (whatsappButton && whatsappButton.textContent.trim() === 'Get OTP on WhatsApp') {
        whatsappButton.textContent = 'حصل الكود على واتساب';
      }
      
      // Replace placeholders
      const phoneInput = document.querySelector('#smlPhoneNumberInput');
      if (phoneInput && phoneInput.placeholder === 'Phone number') {
        phoneInput.placeholder = 'أدخل رقم هاتفك';
      }
      
      const emailInput = document.querySelector('#smlEmailOTPDivUserEmailInput');
      if (emailInput && emailInput.placeholder === 'Enter your email here') {
        emailInput.placeholder = 'أدخل بريدك الإلكتروني هنا';
      }
      
      const otpInputs = document.querySelectorAll('#otpInput, #otpInputSixDigit, #emailOtpInput');
      otpInputs.forEach(input => {
        if (input && input.placeholder === '') {
          input.placeholder = 'أدخل الكود';
        }
      });
      
      // Replace Login/Sign up text
      const loginSignupText = document.querySelector('#simplify-login-sign-up-text');
      if (loginSignupText && loginSignupText.textContent.trim() === 'Login/Sign up') {
        loginSignupText.textContent = 'تسجيل الدخول/إنشاء حساب';
      }
      
      // Replace "Or continue with" text
      const continueText = document.querySelector('#smlContinueText');
      if (continueText && continueText.textContent.trim() === 'Or continue with') {
        continueText.textContent = 'أو تابع مع';
      }
      
      // Replace social login buttons
      const googleButton = document.querySelector('#smlGoogleLoginButtonSpan');
      if (googleButton && googleButton.textContent.trim() === 'Sign in with Google') {
        googleButton.textContent = 'تسجيل الدخول عبر جوجل';
      }
      
      const facebookButton = document.querySelector('#smlFacebookLoginButtonSpan');
      if (facebookButton && facebookButton.textContent.trim() === 'Sign in with Facebook') {
        facebookButton.textContent = 'تسجيل الدخول عبر فيسبوك';
      }
      
      // Replace login method buttons
      const phoneLoginButton = document.querySelector('#loginWithPhoneNumberButton');
      if (phoneLoginButton && phoneLoginButton.textContent.trim() === 'Login/Register with Phone Number') {
        phoneLoginButton.textContent = 'تسجيل الدخول/إنشاء حساب برقم الهاتف';
      }
      
      const biometricButton = document.querySelector('#loginWithBiometricButton');
      if (biometricButton && biometricButton.textContent.trim() === 'Login as') {
        biometricButton.textContent = 'تسجيل الدخول كـ';
      }
      
      const emailPasswordButton = document.querySelector('#loginWithEmailButton');
      if (emailPasswordButton && emailPasswordButton.textContent.trim() === 'Login with Email/Password') {
        emailPasswordButton.textContent = 'تسجيل الدخول بالبريد الإلكتروني/كلمة المرور';
      }
      
      const emailOTPButton = document.querySelector('#loginWithEmailOTPButton');
      if (emailOTPButton && emailOTPButton.textContent.trim() === 'Login with Email/OTP') {
        emailOTPButton.textContent = 'تسجيل الدخول بالبريد الإلكتروني/الكود';
      }
      
      // Replace form field placeholders
      const firstNameInput = document.querySelector('#userFirstNameInput');
      if (firstNameInput && firstNameInput.placeholder === 'First Name*') {
        firstNameInput.placeholder = 'الاسم الأول*';
      }
      
      const lastNameInput = document.querySelector('#userLastNameInput');
      if (lastNameInput && lastNameInput.placeholder === 'Last Name*') {
        lastNameInput.placeholder = 'اسم العائلة*';
      }
      
      const userEmailInput = document.querySelector('#userEmailInput');
      if (userEmailInput && userEmailInput.placeholder === 'Email*') {
        userEmailInput.placeholder = 'البريد الإلكتروني*';
      }
      
      const userPasswordInput = document.querySelector('#userPasswordInput');
      if (userPasswordInput && userPasswordInput.placeholder === 'Password*') {
        userPasswordInput.placeholder = 'كلمة المرور*';
      }
      
      // Replace labels
      const birthdayLabel = document.querySelector('#userBirthdayInputLabel');
      if (birthdayLabel && birthdayLabel.textContent.trim() === 'Birthday') {
        birthdayLabel.textContent = 'تاريخ الميلاد';
      }
      
      const genderLabel = document.querySelector('#userGenderInputLabel');
      if (genderLabel && genderLabel.textContent.trim() === 'Gender') {
        genderLabel.textContent = 'الجنس';
      }
      
      // Replace radio button labels
      const genderRadios = document.querySelectorAll('input[name="userGenderInput"]');
      genderRadios.forEach(radio => {
        const nextSibling = radio.nextSibling;
        if (nextSibling && nextSibling.textContent) {
          if (nextSibling.textContent.trim() === 'Male') {
            nextSibling.textContent = 'ذكر';
          } else if (nextSibling.textContent.trim() === 'Female') {
            nextSibling.textContent = 'أنثى';
          }
        }
      });
      
      // Replace marketing checkbox text
      const marketingText = document.querySelector('#smlAcceptMarketingText');
      if (marketingText && marketingText.textContent.trim() === 'I wish to receive updates on SMS and Email') {
        marketingText.textContent = 'أرغب في تلقي التحديثات عبر الرسائل القصيرة والبريد الإلكتروني';
      }
      
      // Replace terms and conditions text
      const termsText = document.querySelector('#smlTermsAndConditionsText');
      if (termsText && termsText.textContent.includes('I agree to the')) {
        termsText.innerHTML = 'أوافق على <a href="" target="_blank" style="display: inline;">الشروط والأحكام</a>';
      }
      
      // Replace register button
      const registerButton = document.querySelector('#registerUserButton');
      if (registerButton && registerButton.textContent.trim() === 'Login') {
        registerButton.textContent = 'تسجيل الدخول';
      }
    }
  }
  
  // Run immediately
  replaceOTPText();
  
  // Run again after a delay to catch dynamically loaded content
  setTimeout(replaceOTPText, 1000);
  setTimeout(replaceOTPText, 3000);
  setTimeout(replaceOTPText, 5000);
  
  // Use MutationObserver to watch for dynamically added content
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        setTimeout(replaceOTPText, 100);
      }
    });
  });
  
  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
